import { render, staticRenderFns } from "./PlaceDisplayGridElement.vue?vue&type=template&id=70b2af68&"
import script from "./PlaceDisplayGridElement.vue?vue&type=script&lang=js&"
export * from "./PlaceDisplayGridElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports